import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  useTheme,
} from "@material-ui/core";
import {
  Menu as MenuIcon,
  Person as AccountIcon,
  ArrowBack as ArrowBackIcon,
  PowerSettingsNew,
} from "@material-ui/icons";
import classNames from "classnames";
import Logo from "./logo.png";
import jwt_decode from "jwt-decode";

// styles
import useStyles from "./styles";

// components
import { Badge, Typography, Button } from "./wrapper";
import {
  toggleSidebar,
  useLayoutDispatch,
  useLayoutState,
} from "../../context/LayoutContext";
import { useNavigate } from "react-router-dom";

export default function Header(props) {
  var classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const token =localStorage.getItem("signinToken")
  let user 
  if(token){
    var decodedHeader = jwt_decode(localStorage.getItem("signinToken"));
    user =decodedHeader?.user
  }
  


  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  var [profileMenu, setProfileMenu] = useState(null);
  var [isSearchOpen, setSearchOpen] = useState(false);

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classNames(
            classes.headerMenuButtonSandwich,
            classes.headerMenuButtonCollapse
          )}
        >
          {layoutState.isSidebarOpened ? (
            <ArrowBackIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse
                ),
              }}
            />
          ) : (
            <MenuIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse
                ),
              }}
            />
          )}
        </IconButton>
        <img
          alt={"App Logo"}
          style={{
            display: "inline-block",
            height: 60 - theme.spacing(2),
          }}
          src={Logo}
        />
        <div className={classes.grow} />

        <div
          className={classNames(classes.search, {
            [classes.searchFocused]: isSearchOpen,
          })}
        >
          <InputBase
            placeholder="Search…"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
          />
        </div>

        <IconButton
          aria-haspopup="true"
          color="inherit"
          className={classes.headerMenuButton}
          aria-controls="profile-menu"
          onClick={(e) => setProfileMenu(e.currentTarget)}
        >
          <AccountIcon classes={{ root: classes.headerIcon }} />
        </IconButton>

        <Menu
          id="profile-menu"
          open={Boolean(profileMenu)}
          anchorEl={profileMenu}
          onClose={() => setProfileMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser}>
            <Typography variant="h4" weight="medium">
            {user?.name}
            </Typography>
          </div>
          <MenuItem
            className={classNames(
              classes.profileMenuItem,
              classes.headerMenuItem
            )}
            onClick={() => {
              localStorage.clear();
              navigate("/");
            }}
          >
            <PowerSettingsNew
              onClick={() => {
                localStorage.clear();
                navigate("/");
              }}
              className={classes.profileMenuIcon}
            />{" "}
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
